import { Dialog } from "@material-ui/core";
import * as React from "react";
import CommentInput from "src/commentView/CommentInput";
import { Comment } from "src/commentView/types";
import QuiqButton from "src/shared/QuiqButton";
import CloseIcon from "../../documentUpload/close.svg";
import WarningIcon from "./warning-icon.svg";

export interface ConfirmDialogProps {
  dialogOpen: boolean;
  displayText: string;
  onConfirm: (event?: React.MouseEvent<HTMLElement>) => void;
  onCancel: (event?: React.MouseEvent<HTMLElement>) => void;
  onClose: (event: React.MouseEvent<Element, MouseEvent>) => void;
  isLoading: boolean;
  isReject?: boolean;
  spreadId?: string;
  accountId?: string;
  accountName?: string;
  cancelText: string;
  confirmText: string;
  headerText: string;
}

export interface ConfirmDialogState {
  confirmDisabled: boolean;
  submitForm: boolean;
}

export class ConfirmDialog extends React.Component<
  ConfirmDialogProps,
  ConfirmDialogState
> {
  constructor(props: ConfirmDialogProps) {
    super(props);

    this.state = {
      confirmDisabled: props.isReject === true,
      submitForm: false
    };
  }

  public render() {
    return (
      <Dialog
        open={this.props.dialogOpen}
        onClose={this.props.onClose}
        className="ConfirmModal"
        PaperProps={{ className: "ConfirmModal__paper" }}
        transitionDuration={0}
        disableBackdropClick={true}
      >
        <img
          src={CloseIcon}
          className="ConfirmModal__closing-icon"
          onClick={this.props.onClose}
        />
        <img src={WarningIcon} className="ConfirmModal__warning-icon" />
        <div className="ConfirmModal__header">{this.props.headerText}</div>
        <div className="ConfirmModal__content">
          {this.props.displayText}
          {this.props.children}
        </div>

        {this.props.isReject && this.renderComment()}

        <div className="ConfirmModal__button__container">
          <QuiqButton
            onClick={this.props.onCancel}
            variant="text"
            className="ConfirmModal__button__cancel"
            isLoading={this.props.isLoading}
          >
            {this.props.cancelText}
          </QuiqButton>

          <QuiqButton
            onClick={this.onConfirm}
            color="blue"
            className="ConfirmModal__button__confirm"
            isDisabled={this.state.confirmDisabled}
            isLoading={this.props.isLoading}
          >
            {this.props.confirmText}
          </QuiqButton>
        </div>
      </Dialog>
    );
  }

  private renderComment = () => {
    return (
      <div className="ConfirmModal__comment__container">
        <label>Reason For Return</label>
        <CommentInput
          spreadId={this.props.spreadId}
          accountId={this.props.accountId}
          accountName={this.props.accountName}
          className="CommentPopover__input CommentModal__comment__input"
          updateComments={this.updateComments}
          comments={null}
          placeholder="Enter a reason (required)"
          withoutButton={true}
          submitForm={this.state.submitForm}
          onChange={this.onChange}
        />
      </div>
    );
  };

  private onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value.length > 0) {
      this.setState({ confirmDisabled: false });
    } else {
      this.setState({ confirmDisabled: true });
    }
  };

  private onConfirm = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ submitForm: true });
    this.props.onConfirm(event);
  };

  private updateComments = (comments: Comment[]) => {
    if (comments.length > 0) {
      this.setState({ confirmDisabled: false });
    }
  };
}



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/ConfirmDialog.tsx